// @flow

import { selectorByPdbProperty } from '../config';
import { getEntries } from '../../../helpers';
import type { TermFilters, GlobalState } from '../types';

const applyTermFilter = (
  state: GlobalState,
  pdbId: string,
  termFilters?: TermFilters,
): boolean => {
  if (!termFilters) {
    return true;
  }

  return getEntries(termFilters)
    .every(([label, bucket]) => {
      const value = selectorByPdbProperty[label](state, pdbId);
      const sanitizedValue = typeof value === 'string' ? value.trim() : value;
      return bucket.some(b => b === sanitizedValue);
    });
};

export default applyTermFilter;
